import React from 'react';
import { customEvent } from '../../Utilities/GoogleAnalytics';

const Logo = 'https://res.cloudinary.com/stamped/image/upload/v1608735103/General%20Assets/Logo_bqapy8.png';

export default function BuyingSectionCTA() {
  return (
    <>
      <div className="pt-6 pb-6 pl-4 pr-4 m-auto mt-12 mb-1 text-center min-h-lg lg:w-1/3 bg-darkAlt font-brand">
        <h1 className="pt-12 text-2xl font-bold text-gray-900 lg:text-3xl"> Invest in your future wisely. </h1>
        <p className="w-2/3 m-auto mt-4"> Save your money and more importantly, your time. Get 10x the value of a consultancy at x/10th the cost. </p>
      </div>
      <div className="relative max-w-xs pt-10 pb-10 m-auto -mt-48 text-center bg-white border-2 lg:-mt-64 border-brandcolor">
        <p className="pt-8 pb-3 font-medium uppercase">One-Time Payment</p>
        <p className="text-6xl font-bold font-brand text-brandcolor">$50</p>
        <p className="w-2/3 m-auto mb-8 font-medium"> Pay once. Includes all future content updates and lifetime access to tools.</p>
        <a
          onClick={() => customEvent('User', 'Buy Bundle Clicked')}
          className=""
          href="https://gum.co/vZSlH?wanted=true"
          rel="noreferrer"
          data-gumroad-single-product="true"
          target="_blank"
        >
          <button className="w-1/2 pt-2 pb-2 pl-5 pr-5 m-auto text-sm font-bold text-center text-white rounded-sm rounded shadow cursor-pointer bg-brandcolor font-brand">
            Buy Bundle
          </button>
        </a>
        <div className="absolute top-0 -mt-8 ">
          <img src={Logo} className="w-1/4 m-auto" alt="Stamped Logo" />
        </div>
      </div>
    </>
  );
}
